import React, { PropsWithChildren } from 'react';
import { DialogOverlay, Dialog } from '../../../../../../../UILibrary';

type PreviewFilesDialogProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function PreviewFilesDialog({
  children,
  isOpen,
  onClose,
}: PropsWithChildren<PreviewFilesDialogProps>) {
  return (
    <DialogOverlay isOpen={isOpen} zIndexClassName="z-30" handleClose={onClose}>
      <Dialog isOpen={isOpen} maxHeight={840} maxWidth={1220}>
        {children}
      </Dialog>
    </DialogOverlay>
  );
}
